import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { useBreakpoint as h, GenericLink as T, NextgenImage as N, LoaderType as u } from "@nextgen-web-framework/all";
import { getThemeColorClass as v, ThemeShades as C, ThemeColor as f } from "../../utils/themeColor.js";
import { s as t } from "../../ContentCard.module-2ab88d65.mjs";
const x = (e) => {
  var o;
  const r = h(), l = (o = e == null ? void 0 : e.imageList) == null ? void 0 : o.find((c) => {
    var d;
    return (d = c == null ? void 0 : c.viewport) == null ? void 0 : d.includes(r);
  }), n = e.themeColor ? v(
    f[e.themeColor],
    e.themeShade || C.dark
  ) : void 0, s = n || `card-bg-color-${e.backgroundColor || "white"}`, m = n ? "" : `card-color-${e.color || "black"}`;
  return /* @__PURE__ */ i(T, { href: e.url ?? "", className: t["content-card-link"], target: e == null ? void 0 : e.target, children: /* @__PURE__ */ a(
    "div",
    {
      "data-testid": "promotion-card-container-testid",
      className: `${t["content-card-container"]} ${e.customClass}`,
      children: [
        /* @__PURE__ */ i("div", { className: t.banner, children: (l == null ? void 0 : l.url) && /* @__PURE__ */ i(
          N,
          {
            src: l.url,
            alt: (l == null ? void 0 : l.altText) ?? "",
            className: t["content-card-image"],
            loaderType: u.CONTENTSTACK
          }
        ) }),
        /* @__PURE__ */ a(
          "div",
          {
            className: `${t.content} ${t[m]} ${t[s]}  ${t["promotion-card-content"]} `,
            children: [
              /* @__PURE__ */ a("div", { className: t.header, children: [
                /* @__PURE__ */ i("div", { className: t.tag, children: e.tag }),
                e.title && /* @__PURE__ */ i("div", { title: e.title, className: `${t.title}`, children: e.title })
              ] }),
              /* @__PURE__ */ a("div", { className: t.footer, children: [
                e.subTitleLineOne && /* @__PURE__ */ i("div", { className: t["footer-line"], children: e.subTitleLineOne }),
                e.subTitleLineOne && /* @__PURE__ */ i("div", { className: t["footer-line"], children: e.subTitleLineTwo })
              ] })
            ]
          }
        )
      ]
    }
  ) });
};
export {
  x as default
};
//# sourceMappingURL=PromotionCard.js.map
